var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ro_row"},[(_vm.label)?_c('div',{staticClass:"ro_label"},[_vm._v(_vm._s(_vm.label)+":")]):_vm._e(),_c('PnrLink',{attrs:{"individual":_vm.individual,"with-name":_vm.withName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }